module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	var _ = {
		countries: {
			ach: ['United States'],
			sepa: [
				'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland',
				'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg',
				'Malta', 'Netherlands', 'Norway', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden','Switzerland',
				'United Kingdom'
			],
			iban:['Albania', 'Algeria', 'Andorra', 'Angola', 'Azerbaijan', 'Bahrain', 'Bosnia and Herzegovina', 'Benin', 'Brazil', 'Burkina Faso', 'Burundi',
				'Cameroon', 'Cape Verde', 'Costa Rica', 'Dominican Republic', 'East Timor', 'Faroe Islands', 'Guatemala', 'Georgia', 'Greenland', 'Iran',
				'Israel', 'Ivory Coast', 'Jordan', 'Kazakhstan', 'Kuwait', 'Lebanon', 'Macedonia', 'Madagascar','Mauritania', 'Mauritius', 'Mali', 'Moldova',
				'Montenegro', 'Mozambique', 'Pakistan', 'Palestine', 'Qatar', 'Republic of Kosovo','Saudi Arabia', 'Senegal', 'Serbia', 'Tunisia', 'Turkey', 
				'United Arab Emirates', 'Marshal Islands','Gibraltar','Iceland','Liechtenstein','Monaco','San Marino'
				],
			usd: ['United States', 'Canada', 'Australia'],
			dac7: [
				'Austria',
				'Belgium',
				'Bulgaria',
				'Croatia',
				'Cyprus',
				'Czech Republic',
				'Denmark',
				'Estonia',
				'Finland',
				'France',
				//French Overseas Territories
				'Reunion',
				'Martinique',
				'Guadeloupe',
				'French Guiana',
				'Mayotte',
				//
				'Germany',
				'Greece',
				'Hungary',
				'Ireland',
				'Italy',
				'Latvia',
				'Lithuania',
				'Luxembourg',
				'Malta',
				'Netherlands',
				'Poland',
				'Portugal',
				'Romania',
				'Slovakia',
				'Slovenia',
				'Spain',
				'Sweden',
				'United Kingdom',
			  ],
		},

		states: {
			'United States': [{v:'AL',l:'Alabama'},{v:'AK',l:'Alaska'},{v:'AZ',l:'Arizona'},{v:'AR',l:'Arkansas'},{v:'CA',l:'California'},{v:'CO',l:'Colorado'},
				{v:'CT',l:'Connecticut'},{v:'DE',l:'Delaware'},{v:'FL',l:'Florida'},{v:'GA',l:'Georgia'},{v:'HI',l:'Hawaii'},{v:'ID',l:'Idaho'},{v:'IL',l:'Illinois'},
				{v:'IN',l:'Indiana'},{v:'IA',l:'Iowa'},{v:'KS',l:'Kansas'},{v:'KY',l:'Kentucky'},{v:'LA',l:'Louisiana'},{v:'ME',l:'Maine'},{v:'MD',l:'Maryland'},
				{v:'MA',l:'Massachusetts'},{v:'MI',l:'Michigan'},{v:'MN',l:'Minnesota'},{v:'MS',l:'Mississippi'},{v:'MO',l:'Missouri'},{v:'MT',l:'Montana'},
				{v:'NE',l:'Nebraska'},{v:'NV',l:'Nevada'},{v:'NH',l:'New Hampshire'},{v:'NJ',l:'New Jersey'},{v:'NM',l:'New Mexico'},{v:'NY',l:'New York'},
				{v:'NC',l:'North Carolina'},{v:'ND',l:'North Dakota'},{v:'OH',l:'Ohio'},{v:'OK',l:'Oklahoma'},{v:'OR',l:'Oregon'},{v:'PA',l:'Pennsylvania'},
				{v:'RI',l:'Rhode Island'},{v:'SC',l:'South Carolina'},{v:'SD',l:'South Dakota'},{v:'TN',l:'Tennessee'},{v:'TX',l:'Texas'},{v:'UT',l:'Utah'},
				{v:'VT',l:'Vermont'},{v:'VA',l:'Virginia'},{v:'WA',l:'Washington'},{v:'WV',l:'West Virginia'},{v:'WI',l:'Wisconsin'},{v:'WY',l:'Wyoming'}],

			'Canada': [{v:'AB',l:'Alberta'},{v:'BC',l:'British Columbia'},{v:'MB',l:'Manitoba'},{v:'NB',l:'New Brunswick'},{v:'NL',l:'Newfoundland and Labrador'},
				{v:'NS',l:'Nova Scotia'},{v:'ON',l:'Ontario'},{v:'PE',l:'Prince Edward Island'},{v:'QC',l:'Quebec'},{v:'SK',l:'Saskatchewan'},
				{v:'NT',l:'Northwest Territories'},{v:'NU',l:'Nunavut'},{v:'YT',l:'Yukon'}]
		},

		pmAlias: {
			1:'check',
			2:'wire',
			3:'payoneer',
			4:'paxum',
			5:'ach',
			6:'sepa',
			7:'paypal',
			8:'usdt_eth',
			9:'usdt_trc',
			//10: 'skrill'
		},

		pmTitle: {
			1:'Check',
			2:'Wire',
			3:'Firstchoice Pay (Payoneer)',
			4:'Paxum',
			5:'ACH/Direct Deposit',
			6:'SEPA',
			7:'PayPal',
			8:'USDT Ethereum/ERC20 network',
			9:'USDT Tron/TRC20 network',
			//10:'Skrill'
		},

		pmFieldsValuesLabel: {
			'accountType': {
				1: 'Checking account',
				2: 'Savings account'
			},
			'legalType': {
				'Individual': 'Individual',
				'Sole proprietorship': 'Sole proprietorship',
				'Partnership': 'Partnership',
				'LLC': 'Limited liability company (LLC)',
				'Corporation': 'Corporation (Inc., Ltd., Corp.)',
				'Business': 'Business'

			}
		},

		methodFields: [
			[],
			['minPayout','address','city','zipCode','country','legalType'],
			['minPayout', 'bankCode', 'accountNo', 'beneficiaryAddress', 'bankName', 'bankAddress','country','legalType'],
			['minPayout'],
			['paymentEmail', 'paxumConfirmed', 'minPayout', 'legalType', 'country'],
			['minPayout', 'accountType', 'abaCode', 'accountNo','country','legalType'],
			['minPayout', 'bankCode', 'iban', 'beneficiaryAddress', 'bankName', 'bankAddress', 'country','legalType'],
			['paymentEmail', 'minPayout'],
			['minPayout', 'wallet'],
			['minPayout', 'wallet'],
			//['minPayout', 'payableTo', 'paymentEmail']
		],

		dac7Fields: {
			individual: [
			  'dac7Form',
			  'firstNameDac7',
			  'middleName',
			  'lastNameDac7',
			  'birthdateDac7',
			  'tin',
			  'vat',
			  'addressCountry',
			  'addressCity',
			  'addressStreet',
			  'addressBuilding',
			  'zipCodeAddress',
			  'birthCountry',
			  'birthCity',
			],
			business: [
			  'dac7Form',
			  'businessName',
			  'tin',
			  'vat',
			  'addressCountry',
			  'addressCity',
			  'addressStreet',
			  'addressBuilding',
			  'zipCodeAddress',
			],
		},

		/*bankCodes: {
			aba: {
				label: 'ABA/Routing number',
				placeholder: "Add your bank's 9-digit ABA Code",
				regexp: /^\d{9}$/
			},
			swift: {
				label: 'SWIFT/BIC',
				placeholder: "Add your bank's BIC or SWIFT code",
				regexp: /^[A-z]{6}(?:[A-z\d]{2}|[A-z\d]{5})$/
			}
		}*/
	};

	fox.registerWidget('Account_PaymentDetailsFields', {
		configure: function() {
			this.registerOptions('', {

			});
			
			this.callParent('configure', arguments);
		},

		getFormFields: function (paymethod, country, legalType) {
			if (!paymethod){
				return [];
			}
			var fields = _.methodFields[paymethod].slice(0);
			//refactor this hack
			if (_.pmAlias[paymethod] === 'check') {
				if (_.states[country]) {
					fields.push('state');
				}
			}
			if (_.pmAlias[paymethod] === 'wire') {
				if (country === 'United States') {
					fields.push('abaCode');
				} else if (country === 'Canada') {
					fields.push('transitNumber');
					fields.push('institutionNumber');
				}
				if (_.countries.iban.indexOf(country) !== -1 || _.countries.sepa.indexOf(country) !== -1) {
					fields.push('iban');
				}
			}
			if (_.pmAlias[paymethod] === 'paxum') {
				if (legalType === 'Business') {
					fields.push('accountNo');
				} else {
					fields.push('birthdate');
				}
			}
			if (_.pmAlias[paymethod] === 'paxum') {
				if (legalType === 'Business') {
					fields.push('accountNo');
					fields.push('ownershipDocument');
					fields.push('payableTo');
				} else {
					fields.push('birthdate');
					fields.push('firstName');
					fields.push('lastName');
				}
			}
			if (['wire', 'sepa', 'ach', 'check'].includes(_.pmAlias[paymethod])) {
				if (legalType === 'Individual') {
					fields.push('firstName');
					fields.push('lastName');
				} else {
					if(_.pmAlias[paymethod] == 'check'){
						fields.push('payableTo');
					}
					if(_.pmAlias[paymethod] == 'ach'){
						fields.push('beneficiary');
					}
					if(['wire', 'sepa'].includes(_.pmAlias[paymethod])){
						fields.push('beneficiary');
						fields.push('beneficiaryAddress');
					}
				}
				if (legalType === 'LLC' || legalType === 'Corporation') {
					fields.push('ownershipDocument')
				}
				if (legalType === 'Sole proprietorship' || legalType === 'Partnership') {
					fields.push('ownershipDocument')
				}
			}

			if (['wire', 'paxum', 'sepa'].includes(_.pmAlias[paymethod])) {
				if (_.countries.dac7.indexOf(country) !== -1) {
					if ([undefined, '0', 'Individual', ''].includes(legalType)) {
					  fields = fields.concat(_.dac7Fields.individual);
					} else {
					  fields = fields.concat(_.dac7Fields.business);
					}
				}
			}

			return fields;
		},

		getPmAlias: function(alias) {
			return alias ? _.pmAlias[alias] : _.pmAlias;
		},

		getPmTitle: function(alias) {
			return alias ? _.pmTitle[alias] : _.pmTitle;
		},

		getCountries: function(alias) {
			return alias ? _.countries[alias] : _.countries;
		},

		getStates: function(alias) {
			return alias ? _.states[alias] : _.states;
		},

		getPmFieldsValuesLabel: function(alias) {
			return alias ? _.pmFieldsValuesLabel[alias] : _.pmFieldsValuesLabel;
		},

		getPmMethodFields: function(alias) {
			return alias ? _.methodFields[alias] : _.methodFields;
		}

	}, 'Controller');

}(fox, fox.jQuery));
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/account/paymentDetailsFields.js
// module id = 289
// module chunks = 2